import script from "./TimeLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeLimit.vue?vue&type=script&setup=true&lang=js"

import "./TimeLimit.vue?vue&type=style&index=0&id=0bebae8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bebae8c"]])

export default __exports__